module.exports = __webpack_public_path__ + "media/Video 145b.27a07c19.mp4";